import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import { AppSettings } from './../../config/app-settings.js';

function Calendar() {
	const context = React.useContext(AppSettings);
	const plugins = [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin, bootstrapPlugin];
	const headerToolbar = { left: 'dayGridMonth,timeGridWeek,timeGridDay', center: 'title', right: 'prev,next today' };
	const buttonText = { today: 'Today', month: 'Month', week: 'Week', day: 'Day' };
	const views = { timeGrid: { eventLimit: 6 } };
	const [events, setEvents] = React.useState([]);
	const draggableRef = React.useRef(null);
	React.useEffect(() => {
		context.handleSetAppSidebarMinified(true);
		context.handleSetAppContentFullHeight(true);
		context.handleSetAppContentClass('p-0');

		const containerEl = document.getElementById('externalEvents');
		if (containerEl) draggableRef.current = new Draggable(containerEl, { itemSelector: '.fc-event', eventData: (eventEl) => ({ title: eventEl.innerText, color: eventEl.getAttribute('data-color') }) });
		const date = new Date();
		const currentYear = date.getFullYear();
		const currentMonth = String(date.getMonth() + 1).padStart(2, '0');
		setEvents([{ title: 'Trip to London', start: currentYear + '-' + currentMonth + '-01', end: currentYear + '-' + currentMonth + '-05', color: '#00acac' }, { title: 'Meet with Irene Wong', start: currentYear + '-' + currentMonth + '-02T06:00:00', color: '#348fe2' }, { title: 'Mobile Apps Brainstorming', start: currentYear + '-' + currentMonth + '-10', end: currentYear + '-' + currentMonth + '-12', color: '#fb5597' }, { title: 'Stonehenge, Windsor Castle, Oxford', start: currentYear + '-' + currentMonth + '-05T08:45:00', end: currentYear + '-' + currentMonth + '-06T18:00:00', color: '#8753de' }, { title: 'Paris Trip', start: currentYear + '-' + currentMonth + '-12', end: currentYear + '-' + currentMonth + '-16' }, { title: 'Domain name due', start: currentYear + '-' + currentMonth + '-15', color: '#348fe2' }, { title: 'Cambridge Trip', start: currentYear + '-' + currentMonth + '-19' }, { title: 'Visit Apple Company', start: currentYear + '-' + currentMonth + '-22T05:00:00', color: '#00ACAC' }, { title: 'Exercise Class', start: currentYear + '-' + currentMonth + '-22T07:30:00', color: '#f59c1a' }, { title: 'Live Recording', start: currentYear + '-' + currentMonth + '-22T03:00:00', color: '#348fe2' }, { title: 'Announcement', start: currentYear + '-' + currentMonth + '-22T15:00:00', color: '#ff5b57' }, { title: 'Dinner', start: currentYear + '-' + currentMonth + '-22T18:00:00' }, { title: 'New Android App Discussion', start: currentYear + '-' + currentMonth + '-25T08:00:00', end: currentYear + '-' + currentMonth + '-25T10:00:00', color: '#ff5b57' }, { title: 'Marketing Plan Presentation', start: currentYear + '-' + currentMonth + '-25T12:00:00', end: currentYear + '-' + currentMonth + '-25T14:00:00', color: '#348fe2' }, { title: 'Chase due', start: currentYear + '-' + currentMonth + '-26T12:00:00', color: '#f59c1a' }, { title: 'Heartguard', start: currentYear + '-' + currentMonth + '-26T08:00:00', color: '#f59c1a' }, { title: 'Lunch with Richard', start: currentYear + '-' + currentMonth + '-28T14:00:00', color: '#348fe2' }, { title: 'Web Hosting due', start: currentYear + '-' + currentMonth + '-30', color: '#348fe2' }]);
		return () => {
			draggableRef.current?.destroy();
			context.handleSetAppSidebarMinified(false);
			context.handleSetAppContentFullHeight(false);
			context.handleSetAppContentClass('');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<>
			
						
						<div className="calendar">
							
							
							<div className="calendar-sidebar">
								<div id="externalEvents" className="fc-event-list sticky-top z-1">
									<div className="fs-6 fw-bold mb-2">Draggable Events</div>
									<div className="fc-event" data-color="#00acac">
										<div className="fc-event-text">Meeting with Client</div>
										<div className="fc-event-icon"><i className="fas fa-circle fa-fw fs-7px text-success"></i></div>
									</div>
									<div className="fc-event" data-color="#348fe2">
										<div className="fc-event-text">IOS App Development</div>
										<div className="fc-event-icon"><i className="fas fa-circle fa-fw fs-7px text-blue"></i></div>
									</div>
									<div className="fc-event" data-color="#f59c1a">
										<div className="fc-event-text">Group Discussion</div>
										<div className="fc-event-icon"><i className="fas fa-circle fa-fw fs-7px text-warning"></i></div>
									</div>
									<div className="fc-event" data-color="#ff5b57">
										<div className="fc-event-text">New System Briefing</div>
										<div className="fc-event-icon"><i className="fas fa-circle fa-fw fs-7px text-danger"></i></div>
									</div>
									<div className="fc-event">
										<div className="fc-event-text">Brainstorming</div>
										<div className="fc-event-icon"><i className="fas fa-circle fa-fw fs-7px text-dark"></i></div>
									</div>
									<div className="fs-6 fw-bold mb-2 mt-4">Other Events</div>
									<div className="fc-event" data-color="#b6c2c9">
										<div className="fc-event-text">Other Event 1</div>
										<div className="fc-event-icon"><i className="fas fa-circle fa-fw fs-7px text-gray-500"></i></div>
									</div>
									<div className="fc-event" data-color="#b6c2c9">
										<div className="fc-event-text">Other Event 2</div>
										<div className="fc-event-icon"><i className="fas fa-circle fa-fw fs-7px text-gray-500"></i></div>
									</div>
									<div className="fc-event" data-color="#b6c2c9">
										<div className="fc-event-text">Other Event 3</div>
										<div className="fc-event-icon"><i className="fas fa-circle fa-fw fs-7px text-gray-500"></i></div>
									</div>
									<div className="fc-event" data-color="#b6c2c9">
										<div className="fc-event-text">Other Event 4</div>
										<div className="fc-event-icon"><i className="fas fa-circle fa-fw fs-7px text-gray-500"></i></div>
									</div>
									<div className="fc-event" data-color="#b6c2c9">
										<div className="fc-event-text">Other Event 5</div>
										<div className="fc-event-icon"><i className="fas fa-circle fa-fw fs-7px text-gray-500"></i></div>
									</div>
								</div>
							</div>
							
							
							<div className="calendar-body">
								<FullCalendar plugins={plugins} initialView="dayGridMonth" themeSystem="bootstrap" headerToolbar={headerToolbar} buttonText={buttonText} events={events} views={views} droppable editable />
							</div>
							
						</div>
						
					
		</>
	);
}

export default Calendar;
